import React, { useContext, useEffect, useState } from 'react'
import SearchTable from 'src/components/searchTable'
import { CFormSwitch } from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { cilPencil } from '@coreui/icons'
import moment from 'moment'
import CreateRolesModal from './createRolesModal'
import { checkPermissions, raiseToast } from 'src/views/utils/helper'
import { GlobalContext } from '../../../context/GlobalState'
import { PERMISSIONS } from 'src/views/utils/permissions'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDoubleDown } from '@fortawesome/free-solid-svg-icons'
import useAxios from 'axios-hooks'
import { ROLE_LIST_API, ROLE_SCHEMA_API } from '../../../utils/urls'
import { AppContext } from '../../../context/app'

const RolesList = () => {
  const [openModal, setOpenModal] = useState(false)
  const [selectedRole, setSelectedRole] = useState({})
  const [rolesList, setRolesList] = useState([])
  const { setLoader } = useContext(AppContext)
  const { userSessionObj } = useContext(GlobalContext)

  const isCreateAllowed = checkPermissions(
    userSessionObj.session_data.permissions,
    PERMISSIONS.USER_MANAGEMENT.CREATE,
  )
  const isUpdateAllowed = checkPermissions(
    userSessionObj.session_data.permissions,
    PERMISSIONS.USER_MANAGEMENT.UPDATE,
  )

  const [{ data: roleList, loading: roleListLoading }, roleListCall] = useAxios(
    {
      url: ROLE_LIST_API,
      method: 'get',
    },
    { manual: true },
  )

  const [{ data: createRole, loading: createRoleLoading }, roleCreateCall] = useAxios(
    {
      url: ROLE_LIST_API,
      method: 'post',
    },
    { manual: true },
  )

  const [{ data: updateRole, loading: updateRoleLoading }, roleUpdateCall] = useAxios(
    {
      url: ROLE_LIST_API,
      method: 'put',
    },
    { manual: true },
  )

  const [{ data: roleSchema, loading: roleSchemaLoading }] = useAxios({
    url: ROLE_SCHEMA_API,
    method: 'get',
  })

  useEffect(() => {
    roleListCall()
  }, [])

  useEffect(() => {
    setLoader(roleListLoading || createRoleLoading || updateRoleLoading || roleSchemaLoading)
  }, [roleListLoading, createRoleLoading, updateRoleLoading, roleSchemaLoading])

  useEffect(() => {
    if (createRole && createRole.success) {
      roleListCall()
      raiseToast('success', 'Role created successfully')
    }
  }, [createRole])

  useEffect(() => {
    if (updateRole && updateRole.success) {
      roleListCall()
      raiseToast('success', 'Role updated successfully')
    }
  }, [updateRole])

  useEffect(() => {
    if (roleList && roleList.success) {
      setRolesList(roleList.data)
      // let tempArr = roleRes.data.filter(
      //   (ele) => ele.name !== 'subscriber' && ele.name !== 'Account Admin',
      // )
    }
  }, [roleList])

  const handleStatus = (info) => {
    if (!isUpdateAllowed) {
      raiseToast('error', "You don't have enough permission")
      return
    }
    editRole({ status: !info.status }, info._id)
  }

  const addRole = (payload) => {
    roleCreateCall({
      data: payload,
    })
    setOpenModal(false)
  }

  const editRole = (payload, id) => {
    roleUpdateCall({
      params: {
        role_id: id,
      },
      data: payload,
    })
    setOpenModal(false)
  }

  const handleEdit = (info) => {
    if (!isUpdateAllowed) {
      raiseToast('error', "You don't have enough permission")
      return
    }
    setSelectedRole(info)
    setOpenModal(true)
  }

  const handleAdd = () => {
    if (!isCreateAllowed) {
      raiseToast('error', "You don't have enough permission")
      return
    }
    setSelectedRole({})
    setOpenModal(!openModal)
  }

  const tableConfig = [
    {
      header: 'Name',
      dataCell: (info) => info.name,
      width: 22,
    },
    {
      header: 'Description',
      dataCell: (info) => info.description,
      width: 33,
    },
    {
      header: 'Created On',
      dataCell: (info) => moment.utc(info.created_date).format('DD-MM-YYYY'),
      width: 15,
    },
    {
      header: 'Status',
      dataCell: (info) => {
        const disableRoles = ['Subscriber', 'Account Admin']
        return (
          <CFormSwitch
            label={info.status ? 'Active' : 'Disabled'}
            checked={info.status}
            valid={info.status}
            value={info.status}
            onChange={() => handleStatus(info)}
            size="lg"
            disabled={disableRoles.includes(info.name) && info?.is_system_defined}
          />
        )
      },
      width: 16,
    },
    {
      header: <FontAwesomeIcon icon={faAngleDoubleDown} size="lg" className="mx-1" />,
      dataCell: (info) => {
        const disableRoles = ['Subscriber', 'Account Admin']
        const disableFlag = disableRoles.includes(info.name) && info?.is_system_defined
        return (
          <CIcon
            icon={cilPencil}
            style={{ cursor: `${!disableFlag ? 'pointer' : ''}` }}
            size="lg"
            title="Edit"
            onClick={disableFlag ? null : () => handleEdit(info)}
          />
        )
      },
      width: 9,
    },
  ]

  return (
    <>
      <h4>Role List</h4>
      <p>{`Manage Your Roles`}</p>
      <SearchTable
        type={`Roles`}
        tableCardHeight={65}
        disableButton={false}
        buttonName={`+ Add New Role`}
        buttonFunction={handleAdd}
        searchTerm={`name`}
        tableContent={rolesList}
        tableConfig={tableConfig}
        createPermission={isCreateAllowed}
      />

      {openModal && (
        <CreateRolesModal
          openModal={openModal}
          setOpenModal={setOpenModal}
          schema={roleSchema && roleSchema.data}
          roleData={selectedRole}
          addCallback={addRole}
          updateCallback={editRole}
        />
      )}
    </>
  )
}

export default RolesList
